import React from "react";
import withContext from "../../utils/withContext";
import {FullScreen} from "./FullScreen"

function getOptions(context) {
    return [
        {
            blockId: "R-A-1598227-71",
            type: "fullscreen",
            platform: "touch",
            "partner-stat-id": context.analytics_lable
        },
    ];

}

export function AdfoxFull({ context }) {
    const options = getOptions(context);

    if (!options) {
        return null;
    }

    return <FullScreen options={options}/>;
}

export default withContext(AdfoxFull);
